import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class DataSharingService {
  private valueSource = new BehaviorSubject<string>('');
  private users = new BehaviorSubject<Array<any>>([]);
  private usersCount = new BehaviorSubject<any>('');
  private pageNumber = new BehaviorSubject<Array<any>>([]);
  private pageCount = new BehaviorSubject<any>('');
  private currentPage = new BehaviorSubject<number>(1);
  currentUser = this.users.asObservable();
  paginationDiv = this.usersCount.asObservable();
  FileName = this.valueSource.asObservable();
  paginationDelete = this.pageNumber.asObservable();
  pageCountValue = this.pageCount.asObservable();
  firstPageNum = this.currentPage.asObservable();

  constructor() {
  }

  changeUser(users: Array<any>) {
    this.users.next(users);
  }

  changeValue(message: string) {
    this.valueSource.next(message);
  }

  changeBooleanValue(value: string) {
    this.valueSource.next(value);
  }

  changePaginationValue(value: any) {
    this.usersCount.next(value);
  }

  changePaginationArray(pageNumber: Array<any>) {
    this.pageNumber.next(pageNumber);
  }

  changePaginationNumber(pageCount: number) {
    this.pageCount.next(pageCount);
  }

  changeToFirstPage(currentPage: number) {
    this.currentPage.next(currentPage);
  }
}
